import { type FC } from "react";

import { IconButton } from "@/shared/components/ui/icon-button";
import SSNInput from "@/shared/components/SSNInput";
import { Eye, EyeOff } from "lucide-react";

interface SSNFieldProps {
  isEditing: boolean;
  valueFormatted: string;
  onChangeFormatted: (formatted: string) => void;
  savedValue: string;
  ssnVisible: boolean;
  toggleVisible: () => void;
  inputKey: number;
  last4?: string | null;
}

export const SSNField: FC<SSNFieldProps> = ({
  isEditing,
  valueFormatted,
  onChangeFormatted,
  savedValue,
  ssnVisible,
  toggleVisible,
  inputKey,
  last4,
}) => {
  const hasValue = last4 != null ? !!last4 : !!savedValue;
  const displayValue =
    last4 != null
      ? ssnVisible
        ? `XXX-XX-${last4}`
        : "XXX-XX-XXXX"
      : ssnVisible
        ? savedValue
        : "XXX-XX-XXXX";

  return isEditing ? (
    <SSNInput
      key={inputKey}
      valueFormatted={valueFormatted}
      onChangeFormatted={onChangeFormatted}
      ssnVisible={ssnVisible}
      toggleVisible={toggleVisible}
      isDetailMissing={false}
    />
  ) : hasValue ? (
    <div className="flex items-center gap-2">
      <span className="text-sm font-mono">{displayValue}</span>
      <IconButton onClick={toggleVisible} label={ssnVisible ? "Hide SSN" : "Show SSN"}>
        {ssnVisible ? <EyeOff /> : <Eye />}
      </IconButton>
    </div>
  ) : (
    <p className="text-sm text-tertiary">—</p>
  );
};
